<template>
  <div class="pdfYulan">
    <div class="title">预览文件</div>
    <div class="desc">{{ title }}</div>
    <div class="content">
      <ScrollPager
        :total="numPages"
        :nowPage="value"
        @changePage="changePage"
        class="scroll-box"
      >
        <template v-slot:default="{ page: p }">
          <div
            class="item"
            :class="{ active: value == p }"
            :key="pdfSrc + '-' + p"
            @click="changePage(p)"
          >
            <pdf :src="pdfSrc" :page="p" style="width: 100%" class="pdf" />
            <div class="yema">{{ `${p}/${numPages}` }}</div>
          </div>
        </template>
      </ScrollPager>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import ScrollPager from "@/components/ScrollPager/index.vue";
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    pdfSrc: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },

  components: {
    pdf,
    ScrollPager,
  },
  data() {
    return {
      numPages: 0,
    };
  },
  watch: {
    pdfSrc: {
      handler(newValue) {
        if (newValue) {
          this.getPdfPage();
        }
      },
      immediate: true,
    },
  },
  created() {},
  computed: {},
  methods: {
    getPdfPage(page) {
      pdf
        .createLoadingTask({
          url: this.pdfSrc,
        })
        .promise.then((pdfDoc) => {
          this.numPages = pdfDoc.numPages;
        });
    },
    changePage(page) {
      this.$emit("input", page);
    },
  },
};
</script>

<style scoped lang="scss">
.pdfYulan {
  height: 100%;
  display: flex;
  flex-direction: column;
  .title {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;

    font-family: "Noto Sans SC";
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0em;

    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    color: #262626;
  }
  .desc {
    height: 44px;
    width: 100%;
    font-family: "Noto Sans SC";
    font-size: 14px;

    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    color: #262626;
    display: flex;
    align-items: center;
  }
  .content {
    height: calc(100% - 60px - 44px);
    .scroll-box {
      height: 100%;
    }
  }
  .item {
    .pdf {
      box-sizing: border-box;
    }
    .yema {
      height: 33px;
      font-family: "Noto Sans SC";
      font-size: 12px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;

      display: flex;
      justify-content: center;
    }
  }
  .active {
    .pdf {
      box-sizing: border-box;
      border: 1px solid #0062ff;
    }
    .yema {
      color: #0062ff;
    }
  }
}
</style>
